import { render, staticRenderFns } from "./index.vue?vue&type=template&id=61b8a24d&"
import script from "./view.ts?vue&type=script&lang=ts&"
export * from "./view.ts?vue&type=script&lang=ts&"
import style0 from "./view.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports